import {
  OPEN_PARTNER_ORDER,
  SET_PRODUCT_NAME,
  SET_PRODUCT_PRICE,
  SET_ORDER_STEP,
  SET_COURIER_DATA,
  SET_PICKUP_DATA,
  SET_COURIER_ACTIVE_DATE,
  SET_DELIVERY_ACTIVE_OPTION,
  SET_POINTS_VIEW_STATE,
  SET_SEARCH_QUERY,
  SET_ACTIVE_POINT,
  SET_POINTS_COLLAPSED,
  SET_ACTIVE_PAYMENT_SLUG,
  SET_PRODUCT_ID,
  SET_COURIER_ADDRESS,
  SET_COURIER_DATE,
  SET_SUCCESS_MESSAGE,
  SET_DELIVERY_ERRORS,
  SET_PICKUP_SORT_BY,
  SET_PICKUP_REVERSE_STATE,
  SET_AGREEMENT_CONTENT,
  SET_COURIER_TIPS_ADDRESS,
} from './constants';

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_AGREEMENT_CONTENT: {
      return {
        ...state,
        agreement: action.payload,
      };
    }
    case OPEN_PARTNER_ORDER: {
      return {
        ...state,
        showPopup: action.payload,
      };
    }
    case SET_PRODUCT_NAME: {
      return {
        ...state,
        productName: action.payload,
      };
    }
    case SET_PRODUCT_PRICE: {
      return {
        ...state,
        productPrice: action.payload,
      };
    }
    case SET_PRODUCT_ID: {
      return {
        ...state,
        productId: action.payload,
      };
    }
    case SET_ORDER_STEP: {
      return {
        ...state,
        orderStep: action.payload,
      };
    }
    case SET_DELIVERY_ACTIVE_OPTION: {
      return {
        ...state,
        deliveryActiveSlug: action.payload,
      };
    }
    case SET_COURIER_DATA: {
      return {
        ...state,
        courierData: action.payload,
      };
    }
    case SET_COURIER_ACTIVE_DATE: {
      return {
        ...state,
        courierData: {
          ...state.courierData,
          activeDate: action.payload,
        },
      };
    }
    case SET_COURIER_TIPS_ADDRESS: {
      return {
        ...state,
        courierData: {
          ...state.courierData,
          tipsAddress: action.payload,
        },
      };
    }
    case SET_PICKUP_DATA: {
      return {
        ...state,
        pickupData: {
          ...state.pickupData,
          ...action.payload,
        },
      };
    }
    case SET_POINTS_VIEW_STATE: {
      return {
        ...state,
        pickupData: {
          ...state.pickupData,
          pointsViewState: action.payload,
        },
      };
    }
    case SET_PICKUP_SORT_BY: {
      return {
        ...state,
        pickupData: {
          ...state.pickupData,
          sortBy: action.payload,
        },
      };
    }
    case SET_PICKUP_REVERSE_STATE: {
      return {
        ...state,
        pickupData: {
          ...state.pickupData,
          reverseState: action.payload,
        },
      };
    }
    case SET_SEARCH_QUERY: {
      return {
        ...state,
        pickupData: {
          ...state.pickupData,
          searchQuery: action.payload,
        },
      };
    }
    case SET_ACTIVE_POINT: {
      return {
        ...state,
        pickupData: {
          ...state.pickupData,
          activePoint: action.payload,
        },
      };
    }
    case SET_POINTS_COLLAPSED: {
      return {
        ...state,
        pickupData: {
          ...state.pickupData,
          poinsCollapsed: action.payload,
        },
      };
    }
    case SET_ACTIVE_PAYMENT_SLUG: {
      return {
        ...state,
        pickupData: {
          ...state.pickupData,
          activePaymentSlug: action.payload,
        },
      };
    }
    case SET_COURIER_ADDRESS: {
      return {
        ...state,
        courierData: {
          ...state.courierData,
          address: action.payload,
        },
      };
    }
    case SET_COURIER_DATE: {
      return {
        ...state,
        courierData: {
          ...state.courierData,
          activeDate: action.payload,
        },
      };
    }
    case SET_SUCCESS_MESSAGE: {
      return {
        ...state,
        successMessageReplaced: action.payload,
      };
    }
    case SET_DELIVERY_ERRORS: {
      return {
        ...state,
        deliveryErrors: action.payload,
      };
    }
    default:
      return state;
  }
}
